import { Component, OnInit } from '@angular/core';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { CartItem, ICartItem, ICartReviewsLbl, IFilterItemRequest} from 'src/app/core/models';
import { CartService } from '../../../core/services/cart.service';
import { CheckoutService } from '../../../core/services/checkout.service';
import { UserService } from '../../../core/services/user.service';
import { LanguageTranslationService } from '../../../core/services/language-translation.service';

@Component({
  selector: 'app-cart-review',
  templateUrl: './cart-review.component.html',
  styleUrls: ['./cart-review.component.scss']
})
export class CartReviewComponent implements OnInit {
  public cartReviewTxt: ICartReviewsLbl;

  constructor(
    private cartService: CartService,
    private checkoutService: CheckoutService,
    private userService: UserService,
    private languageTranslationService: LanguageTranslationService
  ) { }

  public cartview: GridDataResult;
  public gridData: ICartItem[] = [];
  public getItemListBody: IFilterItemRequest = {
    customerNumber: '',
    itemNumber: '',
    longItemNumber: '',
    pageNo: 1,
    searchQuery: '',
    skip: 0,
    take: 1,
    finishFilter: [],
    categoryFilter: [],
    sort: [
      {
        field: '',
        dir: 'asc',
      },
    ],
    filter: []
  };

  public gridState: State = {
    sort: [
      {
        field: 'lineNumber',
        dir: 'asc',
      },
    ],
    skip: 0,
    take: 10,
    group: [],
  };

  public selectedLang: string = 'eng';
  public showMinOrderFee: boolean = false;
  public minFeeDisplayLine: string = '';
  public topMinOrderFeeValue: number = 0;
  public topMinOrderFeeMessageEng: string = '';
  public topMinOrderFeeMessageFre: string = '';
  public freightAmountChangeSubscription: any;
  public checkOutCConlyCustomer: boolean = false;
  public checkOutCCCustomer: boolean = false;
  public prepaidFreightSelected: boolean = false;
  public freightEstimateFlag: boolean = false;

  public promoCodeEnabled: boolean = false;
  public promoCode: string = '';
  public promoApplied: boolean = false;
  public promoInvalid: boolean = false;
  public promoMessage: string = '';
  public promoMessageColor: string = '';
  promoCodeList: any[] = [];

  ngOnInit(): void {
    this.loadLanguageTranslationData();

    var lang = localStorage.getItem('language');
    if (lang) {
      this.selectedLang = lang;
    }

    this.cartService.getItems1().subscribe((r: ICartItem[]) => {
      this.gridData = r;
      this.bindReviewGridData();
      if (r && r.length > 0) {
        this.checkoutService.checkoutformState.isRCFormValid = true;
        this.checkoutService.checkOutProcessModel.orderTotal = this.cartItemsTotal ;
        this.checkoutService.promoCodeDiscount = this.totalPromoCredit;
      }

      this.loadMinimumOrderFees();
    });

    this.freightAmountChangeSubscription = this.checkoutService.freightAmountChangeSubject.subscribe(val => {
      this.checkoutService.checkOutProcessModel.freightAmount = Number(val);
      this.freightEstimatedShipping;
    });

    if (this.userService.isCheckoutCCCustomer())
      this.checkOutCCCustomer = true;
    else if (this.userService.isCheckoutCConlyCustomer())
      this.checkOutCConlyCustomer = true;
    if (this.userService.getFreightEstimateFlag())
      this.freightEstimateFlag = true;
  }

  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "gridTextLbl1" },
      { controlName: "gridTextLbl2" },
      { controlName: "gridTextLbl3" },
      { controlName: "gridTextLbl4" },
      { controlName: "gridTextLbl5" },
      { controlName: "finishLbl" },
      { controlName: "sizeLbl" },
      { controlName: "quantityLbl" },
      { controlName: "paintLbl" },
      { controlName: "uomLbl" },
      { controlName: "lineLbl" },
      { controlName: "itemLbl" },
      { controlName: "unitLbl" },
      { controlName: "extrusionLbl" },
      { controlName: "descriptionLbl" },
      { controlName: "listPriceLbl" },
      { controlName: "multiplierLbl" },
      { controlName: "unitPriceLbl" },
      { controlName: "extendedPriceLbl" },
      { controlName: "totalPriceLbl" },
    ];
    const componentName = "cartreview";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response && response.length > 0) {
      this.cartReviewTxt = response[response.length - 1];
    }
  }


  //#endregion


  //#region label declaration
  public cartReview = {
    gridTextLbl1: '* Applicable States Sales Tax will be added after the order is processed.',
    gridTextLbl2: '* Shipping Charge will be calculated at the time of order  processing.',
    gridTextLbl3: '* All painted orders will be invoiced at a minimum of $500.00  net per color.',
    gridTextLbl4: '* Shipping costs are estimated and is subject to change',
    gridTextLbl5: '* Shipping costs may still be applicable for Pickup orders if material is not stocked at the pickup facility',
    finishLbl: 'Finish',
    paintLbl: 'Paint',
    sizeLbl: 'Size',
    quantityLbl: 'Quantity',
    uomLbl: 'UoM',
    lineLbl: 'Line #',
    unitLbl: 'Unit',
    itemLbl: 'Item #',
    extrusionLbl: 'Extrusion',
    descriptionLbl: 'Description',
    listPriceLbl: 'List Price',
    multiplierLbl: 'Multiplier',
    unitPriceLbl: 'Unit Price',
    extendedPriceLbl: 'Extended Price',
    totalPriceLbl: 'Total Price',
  };

  public bindReviewGridData() {
    this.cartview = process(this.gridData, this.gridState);
  }

  public reviewPageChange({ skip, take }: PageChangeEvent) {
    this.gridState.skip = skip;
    this.gridState.take = take;
    this.bindReviewGridData();
  }

  public cartReviewGridSortChange(sort): void {
    this.gridState.sort = sort;
    this.bindReviewGridData();
  }
 
  //#endregion
  public updateTotalCartItem(): number {
    if (this.cartview) {
      if (this.cartview.data) {
        return this.cartview.data.length as number;
      }
    }

    return 0;
  }
  cartItemsTotals: Number = 0;
  public get totalPromoCredit(): number {
    if (!this.promoCodeList || this.promoCodeList.length === 0) {
      return 0;
    }

    return this.promoCodeDiscount * -1;
   
  }
  public get cartItemsTotal():number {
    if (this.cartview && this.gridData) {
      return (this.gridData as CartItem[]).map(function (item) {
        return item.extendedPrice;
      }).reduce(function (a, b) {
        return +(a + b).toFixed(2);
      }, 0);
    }
    return 0;
  }

  public getExtendedPrice(dataItem: CartItem): number {
    dataItem.extendedPrice = dataItem.basePrice * dataItem.cmp * dataItem.quantity * 0.94;
    return dataItem.extendedPrice;
  }

  public get freightEstimatedShipping(): number {
    this.prepaidFreightSelected = this.checkoutService.prepaidFreightSelected;
    if (this.checkoutService.checkOutProcessModel.freightAmount) {
      return this.checkoutService.checkOutProcessModel.freightAmount;
    }
    return 0;
  }

  public get displayShippingAmount(): number {

    const isStandardFreight = this.checkoutService.prepaidFreightSelected;

    const hasFreeFreightPromo = this.promoCodeList?.some(
      x => x.freeFreight === 'True'
    );

    if (isStandardFreight && hasFreeFreightPromo) {
      return 0;
    }

    return this.freightEstimatedShipping;
  }

  private loadMinimumOrderFees(): void {
    var custNumber = this.userService.readUserObject.customerNumber;
    if (!custNumber) {
      this.minFeeDisplayLine = '';
      this.showMinOrderFee = false;
      this.topMinOrderFeeValue = 0;
      this.topMinOrderFeeMessageEng = '';
      this.topMinOrderFeeMessageFre = '';
      this.checkoutService.minOrderFee = 0;
      this.checkoutService.minOrderFeeMessage = '';
      return;
    }
    this.cartService.getCartMinimumOrderFees(custNumber).subscribe(
      (r: {
        minApplicableOrderFee: number;
        orderFeesMessageEng: string;
        orderFeesMessageFre: string;
      }) => {

        if (r) {
          if (typeof r.minApplicableOrderFee === 'number') {
            this.topMinOrderFeeValue = r.minApplicableOrderFee;
            this.checkoutService.minOrderFee = this.topMinOrderFeeValue;
          } else {
            this.topMinOrderFeeValue = 0;
          }
          this.topMinOrderFeeMessageEng = r.orderFeesMessageEng || '';
          this.topMinOrderFeeMessageFre = r.orderFeesMessageFre || '';

          if (this.selectedLang === 'fre') {
            this.checkoutService.minOrderFeeMessage =
              this.topMinOrderFeeMessageFre || this.topMinOrderFeeMessageEng;
          } else {
            this.checkoutService.minOrderFeeMessage =
              this.topMinOrderFeeMessageEng || this.topMinOrderFeeMessageFre;
          }
          // language selection
          var msg;
          if (this.selectedLang === 'fre') {
            msg = this.topMinOrderFeeMessageFre;
          } else {
            msg = this.topMinOrderFeeMessageEng;
          }
          if (msg && msg.trim().length > 0) {
            this.minFeeDisplayLine = msg + ': $' + this.topMinOrderFeeValue;
            this.showMinOrderFee = true;
          } else {
            this.minFeeDisplayLine = '';
            this.showMinOrderFee = false;
          }
        } else {
          this.minFeeDisplayLine = '';
          this.showMinOrderFee = false;
          this.topMinOrderFeeValue = 0;
          this.topMinOrderFeeMessageEng = '';
          this.topMinOrderFeeMessageFre = '';
          this.checkoutService.minOrderFee = 0;
          this.checkoutService.minOrderFeeMessage = '';
        }
      },
      (error: any) => {
        this.minFeeDisplayLine = '';
        this.showMinOrderFee = false;
        this.topMinOrderFeeValue = 0;
        this.topMinOrderFeeMessageEng = '';
        this.topMinOrderFeeMessageFre = '';
        this.checkoutService.minOrderFee = 0;
        this.checkoutService.minOrderFeeMessage = '';
      }
    );
  }
  public onPromoToggle(enabled: boolean): void {
    this.promoCodeEnabled = enabled;

    if (!enabled) {
      this.promoCode = '';
      this.promoApplied = false;
      this.promoInvalid = false;
      this.promoMessage = '';
      this.promoMessageColor = '';
    }
  }
  public removePromoCodes(): void {
  this.promoCodeList = [];

  this.checkoutService.promoCodeList = [];
  this.checkoutService.promoCodeDiscount = 0;

  this.promoCode = '';
  this.promoApplied = false;
  this.promoInvalid = false;
    this.promoMessage = '';
    this.promofreefreight = '';
 this.promoMessageColor = '';

 this.checkoutService.promoCodeDiscount = this.totalPromoCredit;
  }
  promofreefreight: any="";
  promoCodeDiscount: any;
  public applyPromoCode(): void {
    if (!this.promoCode || !this.promoCode.trim()) {
      return;
    }
    const code = this.promoCode.trim();
    const allPromoCodes = this.promoCodeList.flat();
    for (let i = 0; i < allPromoCodes.length; i++) {
      if (
        allPromoCodes[i].code === code
      ) {
        this.promoMessage = "Promo code already exists.";
        this.promoInvalid = true;
        this.promoMessageColor = 'red';
        return;
      }
    }
   
    this.promoInvalid = true;
    const payload = {
      promoCode: this.promoCode.trim()
    };
    var custNumber = this.userService.readUserObject.customerNumber;
    this.cartService.GetCartPromoCodeFee(custNumber, this.promoCode, this.cartItemsTotal.toString()).subscribe(
      (r: any) => {
        console.log('Promo API Response:', r);
        if (r && r.length > 0) {

          if (r[0].applicablePromoCode === "Yes") {
            if ((r[0].freeFreight == 'True' && r[0].promofreefreight == 'P') || (r[0].freeFreight == 'True' && r[0].promofreefreight == 'CPT'))
            {
              this.promofreefreight = r[0].promofreefreight
            }
            this.promoMessage = "Valid PromoCode";
            this.promoInvalid = false;
            this.promoMessageColor = 'green';

            this.promoCodeList.push(...r);
            this.promoCodeDiscount = r[0].totalDiscount;
            this.checkoutService.promoCodeList = [...this.promoCodeList];
            this.checkoutService.promoCodeDiscount = this.totalPromoCredit;
            this.checkoutService.promofreefreight = this.promofreefreight;
          }
          else {

            this.promoMessage = r[0].applicablePromoCode;
            this.promoInvalid = true;
            this.promoMessageColor = 'red';
            return;
          }
        }
      },
      (error: any) => {
        this.checkoutService.promoCodeList = [];
        this.checkoutService.promoCodeDiscount = 0;
      }
    );
    console.log('Promo Code Payload:', payload);
  }
}
